import { render, staticRenderFns } from "./EventHotelsMap.vue?vue&type=template&id=8d1af9c4&"
import script from "./EventHotelsMap.vue?vue&type=script&lang=js&"
export * from "./EventHotelsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports